"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenshareToggle = void 0;
var _reactIcons = require("@100mslive/react-icons");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _useUISettings = require("./AppData/useUISettings");
var _utils = require("../common/utils");
var _constants = require("../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ScreenshareToggle = function ScreenshareToggle(_ref) {
  var css = _ref.css;
  var isAllowedToPublish = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsAllowedToPublish);
  var isAudioOnly = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.isAudioOnly);
  var _useScreenShare = (0, _reactSdk.useScreenShare)(),
    amIScreenSharing = _useScreenShare.amIScreenSharing,
    video = _useScreenShare.screenShareVideoTrackId,
    toggleScreenShare = _useScreenShare.toggleScreenShare;
  var isVideoScreenshare = amIScreenSharing && !!video;
  if (!isAllowedToPublish.screen || !(0, _utils.isScreenshareSupported)()) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
    title: "".concat(!isVideoScreenshare ? "Start" : "Stop", " screen sharing"),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      active: !isVideoScreenshare,
      css: css,
      disabled: isAudioOnly,
      onClick: function onClick() {
        toggleScreenShare();
      },
      "data-testid": "screen_share_btn",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ShareScreenIcon, {})
    })
  });
};
exports.ScreenshareToggle = ScreenshareToggle;